__webpack_require__.p = "/osttra-sso-login-frontend/latest/";